import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import SearchResults from './pages/search-results';
import TrailerDetail from './pages/trailer-detail';
import HomePage from './pages/home-page';
import Booking from './pages/booking';
import TrailerListingCreation from './pages/trailer-listing-creation';
import Login from './pages/login';
import Signup from './pages/signup';
import RenterDashboard from './pages/renter-dashboard';
import OwnerDashboard from './pages/owner-dashboard';
import MessagingCenter from './pages/messaging-center';
import ReviewsManagement from './pages/reviews-management';
import BookingConfirmation from './pages/booking-confirmation';
import Checkout from './pages/checkout';
import StateTowingRegulations from './pages/state-towing-regulations';
import PayoutManagement from './pages/payout-management';
import AdminPlatformManagement from './pages/admin-platform-management';
import AdminSettings from './pages/admin-settings';
import AdminDashboard from './pages/admin-dashboard';
import TrailerReturnInspection from './pages/trailer-return-inspection';
import TermsOfService from './pages/terms-of-service';
import PrivacyPolicy from './pages/privacy-policy';
import DisputeResolution from './pages/dispute-resolution';
import RenterViolationCharges from './pages/renter-violation-charges';
import ChargeDispute from './pages/charge-dispute';
import OwnerDisputeReview from './pages/owner-dispute-review';
import CookiePolicy from './pages/cookie-policy';
import PublicUserProfile from './pages/public-user-profile';
import RenterCheckInProcess from './pages/renter-check-in-process';
import ForgotPassword from './pages/forgot-password';
import ResetPassword from './pages/reset-password';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomePage />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/trailer-detail/:id" element={<TrailerDetail />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/booking-confirmation" element={<BookingConfirmation />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/home-page" element={<HomePage />} />
        <Route path="/trailer-listing-creation" element={<TrailerListingCreation />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/renter-dashboard" element={<RenterDashboard />} />
        <Route path="/owner-dashboard" element={<OwnerDashboard />} />
        <Route path="/messaging-center" element={<MessagingCenter />} />
        <Route path="/reviews-management" element={<ReviewsManagement />} />
        <Route path="/state-towing-regulations" element={<StateTowingRegulations />} />
        <Route path="/payout-management" element={<PayoutManagement />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/admin-platform-management" element={<AdminPlatformManagement />} />
        <Route path="/admin-settings" element={<AdminSettings />} />
        <Route path="/trailer-return-inspection" element={<TrailerReturnInspection />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/dispute-resolution" element={<DisputeResolution />} />
        <Route path="/renter-violation-charges" element={<RenterViolationCharges />} />
        <Route path="/charge-dispute" element={<ChargeDispute />} />
        <Route path="/owner-dispute-review" element={<OwnerDisputeReview />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/public-user-profile" element={<PublicUserProfile />} />
        <Route path="/renter-check-in-process" element={<RenterCheckInProcess />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
